var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.youTubeUrlTitle)?_c('maptivateInfoButton',{attrs:{"Site_Marker_Number":_vm.Site_Marker_Number,"isPopup":_vm.isPopup,"butType":"playVideo","width":_vm.width,"color":_vm.appSettings.mediaButtonColor,"icon":"mdi-youtube-tv","title":_vm.youTubeUrlTitle.title,"clickfunction":function () {
      _vm.openYoutube(_vm.youTubeUrlTitle.url, _vm.Point_Name);
    }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }